import { DragDataTypes, type DragData } from '@modules/drag-n-drop/types/drag-data';
import { type Board } from '../../types/board';
import { toBoardStitchSummary } from './board-stitch-summary.util';

/** Carries stitch summaries across apps and preserves the original boards for Boards move targets. */
export function toBoardDragData(boards: Board[], accountId = ''): DragData {
  return {
    type: DragDataTypes.board,
    data: boards.map((board) => ({
      ...toBoardStitchSummary(board, accountId),
      description: board.description,
      tags: board.tags,
      knots: board.knots,
      connections: board.connections,
      sourceBoard: board,
    })),
  };
}

function isDraggedBoard(value: unknown): value is Board {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    typeof value.id === 'string' &&
    'title' in value &&
    typeof value.title === 'string' &&
    'headVersion' in value &&
    typeof value.headVersion === 'number'
  );
}

export function boardsFromDragData(dragData: DragData): Board[] {
  if (dragData.type !== DragDataTypes.board) {
    return [];
  }
  const items: readonly unknown[] = dragData.data;
  return items.flatMap((item) => {
    if (!item || typeof item !== 'object' || !('sourceBoard' in item)) return [];
    return isDraggedBoard(item.sourceBoard) ? [item.sourceBoard] : [];
  });
}
